import type { RouteRecordRaw } from "vue-router";

const ApiOrderView = () => import("@views/api-order/api-order-view.vue");
const Step1View = () => import("@views/api-order/step-1-view.vue");
const Step2View = () => import("@views/api-order/step-2-view.vue");
const Step3View = () => import("@views/api-order/step-3-view.vue");
const Step4View = () => import("@views/api-order/step-4-view.vue");
const Step5View = () => import("@views/api-order/step-5-view.vue");
const ApiOrderEndView = () => import("@views/api-order/api-order-end-view.vue");

export function guardApiOrderStep(_step: number) {
    // Step guard bomo uredili kasneje.
    return true;
}

export const apiOrderRoutes: RouteRecordRaw[] = [
    {
        component: ApiOrderView,
        name: "apiOrder_home",
        path: "api-order",

        // beforeEnter: (_to, from) => {
        //     if (from.matched.length === 0) {
        //         return { name: "dashboard_dashboard", replace: true };
        //     }
        //
        //     return true;
        // },

        redirect: {
            name: "ApiOrderStep1"
        },

        children: [
            {
                path: "step-1",
                name: "ApiOrderStep1",
                component: Step1View,
                beforeEnter: () => guardApiOrderStep(1),
                meta: {
                    stepId: 1,
                    buttons: [
                        {
                            name: "Cancel",
                            action: "cancel",
                            label: "Cancel",
                            class: "default-outline",
                            visible: true
                        },
                        {
                            name: "Next",
                            action: "validateStep1",
                            label: "Next",
                            visible: true
                        }
                    ],
                    navigation: {
                        nextStep: "ApiOrderStep2",
                        contractlist: "seznam_pogodb_home"
                    }
                }
            },
            {
                path: "step-2",
                name: "ApiOrderStep2",
                component: Step2View,
                beforeEnter: () => guardApiOrderStep(2),
                meta: {
                    stepId: 2,
                    buttons: [
                        {
                            name: "Next",
                            action: "validateStep2",
                            label: "Next",
                            visible: true
                        }
                    ],
                    navigation: {
                        nextStep: "ApiOrderStep3",
                        end: "ApiOrderEnd",
                        contractlist: "seznam_pogodb_home"
                    }
                }
            },
            {
                path: "step-3",
                name: "ApiOrderStep3",
                component: Step3View,
                beforeEnter: () => guardApiOrderStep(3),
                meta: {
                    stepId: 3,
                    buttons: [
                        {
                            name: "Next",
                            action: "validateStep3",
                            label: "Next",
                            visible: true
                        }
                    ],
                    navigation: {
                        nextStep: "ApiOrderStep4",
                        end: "ApiOrderEnd"
                    }
                }
            },
            {
                path: "step-4",
                name: "ApiOrderStep4",
                component: Step4View,
                beforeEnter: () => guardApiOrderStep(4),
                meta: {
                    stepId: 4,
                    buttons: [
                        {
                            name: "Next",
                            action: "validateStep4",
                            label: "Next",
                            visible: true
                        }
                    ],
                    navigation: {
                        nextStep: "ApiOrderStep5",
                        end: "ApiOrderEnd"
                    }
                }
            },
            {
                path: "step-5",
                name: "ApiOrderStep5",
                component: Step5View,
                beforeEnter: () => guardApiOrderStep(5),
                meta: {
                    stepId: 5,
                    buttons: [
                        {
                            name: "Next",
                            action: "validateStep5",
                            label: "Next",
                            visible: true
                        }
                    ],
                    navigation: {
                        endSuccess: "ApiOrderEndSuccess",
                        endFail: "ApiOrderEndFail"
                    }
                }
            },

            // Obstoječi zaključek za prejšnje korake.
            {
                path: "end",
                name: "ApiOrderEnd",
                component: ApiOrderEndView,
                meta: {
                    stepId: -1,
                    buttons: [
                        {
                            name: "ToContractList",
                            action: "close",
                            label: "ToContractList",
                            visible: true
                        }
                    ],
                    navigation: {
                        contractlist: "seznam_pogodb_home"
                    }
                }
            },

            // Uspešno podpisane vse pogodbe.
            {
                path: "end-success",
                name: "ApiOrderEndSuccess",
                component: ApiOrderEndView,
                meta: {
                    stepId: -1,
                    resultStatus: "success",
                    buttons: [
                        {
                            name: "ToContractList",
                            action: "close",
                            label: "ToContractList",
                            visible: true
                        }
                    ],
                    navigation: {
                        contractlist: "seznam_pogodb_home"
                    }
                }
            },

            // Neuspešen podpis pogodbe.
            {
                path: "end-fail",
                name: "ApiOrderEndFail",
                component: ApiOrderEndView,
                meta: {
                    stepId: -1,
                    resultStatus: "fail",
                    buttons: [
                        {
                            name: "ToContractList",
                            action: "close",
                            label: "ToContractList",
                            visible: true
                        }
                    ],
                    navigation: {
                        contractlist: "seznam_pogodb_home"
                    }
                }
            }
        ]
    }
];